import React from "react";
import Dashboard from "../../common/Dashboard";
import DashboardConfig from "../system-admin/Dashboard/DashboardConfig";

export default function CashCounterDashboard() {
  return (
    <Dashboard sidebarType="Cash Counter">
      <DashboardConfig />
    </Dashboard>
  );
}
